import styled from "styled-components";

export const TitleHIW = styled.div`
  text-align: center;
  color: #FF8A00;
  font-size: 35px;
  font-weight: 700;

  @media (max-width: 1200px) {
    font-size: 28px;
    font-weight: 700;
  }
`;

export const SubTitleWIT = styled.div`
  text-align: center;
  color: #8E8181;
  font-size: 18px;
  font-weight: 300;
  padding-top: 18px;

  @media (max-width: 1200px) {
    font-size: 16px;
  }
`;

